import React, { Component } from 'react';
import { connect } from 'react-redux';

import { 
  PLUS_INDEX_FIRST_LEVEL,
  MINUS_INDEX_FIRST_LEVEL,
  PLUS_INDEX_SECOND_LEVEL,
  MINUS_INDEX_SECOND_LEVEL,
  PLUS_INDEX_THIRD_LEVEL,
  MINUS_INDEX_THIRD_LEVEL,
  PLUS_INDEX_FOURTH_LEVEL,
  MINUS_INDEX_FOURTH_LEVEL,
  PLUS_INDEX_FOURTH_LEVEL_NEXT,
  MINUS_INDEX_FOURTH_LEVEL_PREV,
  PLUS_INDEX_FIFTH_LEVEL,
  MINUS_INDEX_FIFTH_LEVEL,
  PLUS_INDEX_FIFTH_LEVEL_NEXT,
  MINUS_INDEX_FIFTH_LEVEL_PREV,
  PLUS_INDEX_SIXTH_LEVEL_NEXT,
  MINUS_INDEX_SIXTH_LEVEL_PREV,
  showStartMenu,
  switchStartMenu,
  plusMenuLevel, 
  minusMenuLevel, 
  plusIndex, 
  minusIndex,
} from './actionCreators';

import CameraMenu from './CameraMenu';
import Topbar from './menuTypes/Topbar';
import StartMenu from './menuTypes/StartMenu';
import {
  OkButton,
  RoundButton,
  NavigationButton
} from './elements/CameraButtons';

import { handleAnimationOn, handleAnimationOff } from './helpers/animations.js';
import { recFormatDictionaryReverse } from './helpers/recFormatDictionary.js';

class Camera extends Component {
  
  componentDidMount() {
    document.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKey);
  }

  showMenu = (e) => {
    e.preventDefault();
    e.target.blur();
    this.props.switchStartMenu();
  }

  moveToNext = (e) => {
    e.preventDefault();
    e.target.blur();
    handleAnimationOn('right');

    document.addEventListener('keyup', (e) => {
      if(e.key === "ArrowRight") {
        handleAnimationOff('right'); document.removeEventListener('keyup', ()=>{})
      }
    });
    document.addEventListener('mouseup', () => {handleAnimationOff('right'); document.removeEventListener('mouseup', ()=>{})});

    if(this.props.showMenu === false) { return; }
  
    switch (this.props.menuLevel) {
      case 1:
        this.props.plusIndex(PLUS_INDEX_FIRST_LEVEL);
        break;
      case 3:
        if(this.props.showSubList === true) { return; }
        this.props.plusIndex(PLUS_INDEX_SECOND_LEVEL);
        break;
      case 4:
        if(this.props.showSubList === true) { return; }
        this.props.plusIndex(PLUS_INDEX_FOURTH_LEVEL_NEXT);
        break;
      case 5:
        if(this.props.showSubList === true) { return; }
        this.props.plusIndex(PLUS_INDEX_FIFTH_LEVEL_NEXT);
        break;
      case 6: 
        this.props.plusIndex(PLUS_INDEX_SIXTH_LEVEL_NEXT);
        break;
      default:
        break;
    }
  }

  moveToPrev = (e) => {
    e.preventDefault();
    e.target.blur();
    handleAnimationOn('left');

    document.addEventListener('keyup', (e) => {
      if(e.key === "ArrowLeft") {
        handleAnimationOff('left'); document.removeEventListener('keyup', ()=>{})
      }
    });
    document.addEventListener('mouseup', () => {handleAnimationOff('left'); document.removeEventListener('mouseup', ()=>{})});

    if(this.props.showMenu === false) { return; }

    switch (this.props.menuLevel) {
      case 1:
        this.props.minusIndex(MINUS_INDEX_FIRST_LEVEL);
        break;
      case 3:
        if(this.props.showSubList === true) { return }
        this.props.minusIndex(MINUS_INDEX_SECOND_LEVEL);
        break;
      case 4:
        if(this.props.showSubList === true) { return; } 
        this.props.minusIndex(MINUS_INDEX_FOURTH_LEVEL_PREV);
        break;
      case 5:
        if(this.props.showSubList === true) { return; }
        this.props.minusIndex(MINUS_INDEX_FIFTH_LEVEL_PREV);
        break;
      case 6: 
        this.props.minusIndex(MINUS_INDEX_SIXTH_LEVEL_PREV);
        break;
      default:
        break;
    }
  }

  moveUp = (e) => {
    e.preventDefault();
    e.target.blur();
    handleAnimationOn('top');

    document.addEventListener('keyup', (e) => {
      if(e.key === 'ArrowUp') {
        handleAnimationOff('top'); document.removeEventListener('keyup', ()=>{})
      }
    });
    document.addEventListener('mouseup', () => {handleAnimationOff('top'); document.removeEventListener('mouseup', ()=>{})});

    if(this.props.showMenu === false) { return; }

    switch (this.props.menuLevel) {
      case 1:
        this.props.minusMenuLevel();
        break;
      case 3:
          if(this.props.showSubList === true) {
            this.props.minusIndex(MINUS_INDEX_FOURTH_LEVEL);
          } else {
            this.props.minusIndex(MINUS_INDEX_THIRD_LEVEL);
          }
        break;
      case 4:
        if(this.props.showSubList === true) {
          this.props.minusIndex(MINUS_INDEX_FIFTH_LEVEL);
        } else {
          this.props.minusIndex(MINUS_INDEX_FOURTH_LEVEL);
        }
        break;
      case 5:
        this.props.minusIndex(MINUS_INDEX_FIFTH_LEVEL);
         break;
        default: break;
    }
  }

  moveDown = (e) => {
    e.preventDefault();
    e.target.blur();
    handleAnimationOn('down');
    
    document.addEventListener('keyup', (e) => {
      if(e.key === 'ArrowDown') {
        handleAnimationOff('down'); document.removeEventListener('keyup', ()=>{})
      }
    });
    document.addEventListener('mouseup', () => {handleAnimationOff('down'); document.removeEventListener('mouseup', ()=>{})}); 
    
    if(this.props.showMenu === false) { return; }

    switch (this.props.menuLevel) {
      case 1:
        this.props.plusMenuLevel();
        break;
      case 3:
          if(this.props.showSubList === true) {
            this.props.plusIndex(PLUS_INDEX_FOURTH_LEVEL);
          } else {
            this.props.plusIndex(PLUS_INDEX_THIRD_LEVEL);
          }
        break;
      case 4:
        if(this.props.showSubList === true) {
          this.props.plusIndex(PLUS_INDEX_FIFTH_LEVEL);
        } else {
          this.props.plusIndex(PLUS_INDEX_FOURTH_LEVEL);
        }
        break;
      case 5:
        this.props.plusIndex(PLUS_INDEX_FIFTH_LEVEL);
        break;
      default: break;
    }
  }

  showMore = (e) => {
    e.preventDefault();
    e.target.blur();

    if(this.props.showMenu === false) { return; }
   
    switch (this.props.menuLevel) {
      case 1:
        if(this.props.firstLevelIndex === Object.keys(this.props.data).length - 1) {
          this.props.showStartMenu();
        }
        break;
      default:
        this.props.plusMenuLevel();
        break;
    }
  }

  cancel = (e) => {
    e.preventDefault();
    e.target.blur();

    if(this.props.showMenu === false) { return; }
    
    switch (this.props.menuLevel) {
      case 1:
        this.props.showStartMenu();
        break;
      default:
        this.props.minusMenuLevel();
        break;
    }
  }

  handleKey = (e) => {
    if (e.key === 'ArrowRight') {
      this.moveToNext(e);
    }
    if (e.key === 'ArrowLeft') {
      this.moveToPrev(e);
    }
    if (e.key === 'ArrowUp') {
      this.moveUp(e);
    }
    if (e.key === 'ArrowDown') {
      this.moveDown(e);
    }
    if (e.key === 'Enter') {
      this.showMore(e);
    }
    if (e.key === 'Escape') {
      this.cancel(e);
    }
  }

  render() {
    const {
      showMenu,
      menuLevel,
      firstLevelIndex,
      secondLevelIndex,
      thirdLevelIndex,
      fourthLevelIndex,
      fifthLevelIndex,
      sixLevelIndex,
      topbar,
      data,
      showSubList
    } = this.props;

    let recFormat = recFormatDictionaryReverse[data["Recording/Media Setup"].settings['1'].settings['Main Rec Format'].default];
    let framerate = data["Recording/Media Setup"].settings['2'].settings['Frame Rate'].default;

    let resColor = data["Recording/Media Setup"].settings["2"].settings["Resolution/Color Sampling"].default;
    let resolution = resColor.substr(0,resColor.indexOf(' '));
    let colorSampling = resColor.substr(resColor.indexOf(' ')+1);

    if (recFormat === 'raw' && framerate !== '59.94P') {
      colorSampling = '12bit';
    }

    const MenuToRender = showMenu 
      ? <CameraMenu
          dataMenu={data}
          menuLevel={menuLevel}
          firstLevelIndex={firstLevelIndex}
          secondLevelIndex={secondLevelIndex}
          thirdLevelIndex={thirdLevelIndex}
          fourthLevelIndex={fourthLevelIndex}
          fifthLevelIndex={fifthLevelIndex}
          sixLevelIndex={sixLevelIndex}
          showSubList={showSubList}
      />
    : <StartMenu resolution={resolution} colorSampling={colorSampling}/>
    return (
      <>
        <div className="Camera-screen">
            <Topbar visibility={topbar} recFormat={recFormat} frameRateIcon={framerate}  resolution={resolution} />
            {MenuToRender}
        </div>
        <div className="Buttons-container">
            <RoundButton label="Func" buttonText="1" />
            <RoundButton label="Menu" eventHandler={this.showMenu} />
            <div className="Buttons-navigation-wrapper">
                <NavigationButton direction="left" eventHandler={this.moveToPrev} />
                <NavigationButton direction="right" eventHandler={this.moveToNext} />
                <NavigationButton direction="top" eventHandler={this.moveUp} />
                <NavigationButton direction="bottom" eventHandler={this.moveDown} />
                <OkButton eventHandler={this.showMore} />
            </div>
            <RoundButton label="Disp" buttonText="2" />
            <RoundButton label="Cancel" eventHandler={this.cancel} />
        </div>
      </>
    );
  }
}

function mapStateToProps(reduxState) {
  return {
    showMenu: reduxState.showMenu,
    menuLevel: reduxState.menuLevel,
    firstLevelIndex: reduxState.firstLevelIndex,
    secondLevelIndex: reduxState.secondLevelIndex,
    thirdLevelIndex: reduxState.thirdLevelIndex,
    fourthLevelIndex: reduxState.fourthLevelIndex,
    fifthLevelIndex: reduxState.fifthLevelIndex,
    sixLevelIndex: reduxState.sixLevelIndex,
    topbar: reduxState.topbar,
    data: reduxState.data,
    showSubList: reduxState.showSubList,
  }
}

export default connect(mapStateToProps, {showStartMenu, switchStartMenu, plusMenuLevel, minusMenuLevel, plusIndex, minusIndex})(Camera);
